import BlogPage from 'src/views/Marketing/Blog/components/BlogPage';
import Footer from 'src/views/Marketing/components/Footer';
import NavBar from 'src/views/Marketing/components/NavBar';
import { ScrollView, StyleSheet } from 'react-native';

export default function Page() {
  return (
    <ScrollView style={styles.scrollView}>
      <NavBar />
      <BlogPage author='OneShop Team' dateTime='2022-02-22' tag='Mercari' title='Mercari W-9 Requirements for 2022'>
        <p>
          In an effort to maintain a level of accountability, marketplaces such as Mercari have been updating their W-9
          requirements for sellers. Starting January 1, 2022, Mercari will require sellers with $600 or more gross sales
          to submit a W-9. The Internal Revenue Services (IRS) and state tax agencies use the W-9 for income reporting
          purposes.{' '}
        </p>
        <p>
          This information helps them determine how much taxes should be withheld from an individual's paychecks and
          what percentage of sales taxes they owe. Sellers who do not submit their W-9s could face significant fines,
          account restrictions, and limitations.{' '}
        </p>
        <p>
          With the new changes, there are several things that you need to know about W-9, its requirements, and how to
          keep your tax identification information up to date. This blog will also break down the basics of Mercari w-9,
          its importance, and the penalty sellers faced when they failed to submit their w-9 on time.{' '}
        </p>

        <h3>What is Mercari W9</h3>
        <p>
          More and more marketplaces require their sellers to fill out a substitute w-9 form and update their tax
          information. One of which is Mercari. This information ensures a timely and accurate filling of Form 1099-K
          with the IRS (Internal Revenue Service){' '}
        </p>
        <p>
          However, not everyone is required to fill out a substitute w-9 form—only those marketplaces sellers who gross
          $600 or more in sales in a calendar year. If you are a new Mercari seller, this might be too much to take in.
          So we'll break down the basics and determine if you are one of the sellers required to submit their updated
          tax information.{' '}
        </p>

        <h3>W-9 Requirements </h3>
        <p>
          Online marketplaces like Mercari are required to collect tax information from individuals and sellers who
          gross $600 or more sales in a calendar year. The previous threshold was $20,000, but it was lowered to $600
          this calendar year.
        </p>
        <p>
          If you are a Mercari seller with a gross sale of $600 or more beginning January 2022, you must fill out a
          substitute w-9 form. The new tax reporting does not affect your existing requirements from the last calendar
          year, 2021.
        </p>
        <p>
          Meaning the sales count will start from January 1, 2022, until you reach the $600 threshold of that calendar
          year. For example, your total gross sales reached $600 in November 2022. Then you will receive a request from
          Mercari to fill out the w-9 form. In this way, you can continue to sell on Mercari after the $600 new
          threshold.
        </p>
        <p>Mercari sellers will be asked to update their tax information on two bases: </p>
        <ul>
          <li>Sellers need to update their w-9 information on each applicable calendar year </li>
          <li>
            Sellers need to update and confirm their w-9 information when they reach the IRS gross payments reporting
            thresholds.{' '}
          </li>
        </ul>

        <p>The following tax and personal information are needed when updating your tax information in Mercari: </p>
        <ul>
          <li>Your legal first and last name </li>
          <li>Your Social Security Number (SSN) or Individual Tax Identification Number (ITIN)</li>
          <li>Your Current Mailing Address </li>
          <li>Tax Classification (i.e., individual or business) </li>
        </ul>

        <p>
          If you are classified under business entities, you may be asked some more information such as the following:{' '}
        </p>
        <ul>
          <li>Legal Name of Entity</li>
          <li>Employer Identification Number</li>
          <li>Registered Business Name</li>
          <li>Registered Mailing Address of Entity </li>
        </ul>

        <p>
          Additional information may be requested after providing your Tax Identification Number. Sellers without Social
          Security Numbers will be asked to provide their Tax ID Number (ITIN) instead.{' '}
        </p>
        <p>
          Mercari needs these pieces of information to file a complete, timely, and accurate Form 1099-K to IRS. Mercari
          will also verify the tax identification information you submitted with third-party verification providers and
          applicable federal and taxing authorities.{' '}
        </p>

        <h4>Account Restrictions and Penalty </h4>
        <p>
          When requested, sellers who fail to submit their substitute w-9 form may experience account limitations and
          restrictions in selling on Mercari. To resolve any restrictions and continue to sell after the gross sales
          threshold, the seller needs to provide information and submit their missing w-9 form.{' '}
        </p>
        <p>
          If the seller submitted an incorrect or incomplete substitute w-9 form, they might still experience
          restrictions in their account. Mercari will verify the tax identification numbers with third-party providers
          to determine that the Mercari account owner matches the information on record with the IRS and applicable
          federal and state taxing authorities.{' '}
        </p>

        <h3>W-9 Process </h3>
        <p>
          The new tax reporting process can be a bit overwhelming for new sellers. This information is essential in
          reporting your taxes accurately and timely. Mercari has always been considerate of its sellers. They will send
          a reminder when your gross sale is nearing the $600 threshold. This way, you can have ample time to fill out
          and submit them.{' '}
        </p>

        <h4>How to Access Gross Sales Report</h4>
        <p>
          The Gross Sales Reports provide detailed information and insights into all your transactions in the Mercari.
          The data allows you to monitor your sales, improve your listings, determine your average sale price, sales
          growth, and total profit.{' '}
        </p>
        <p>To monitor and view your gross sales, follow the step by step guide below: </p>
        <ol>
          <li>Log in to your Mercari account </li>
          <li>Click "Account" then select "Seller Dashboard." </li>
          <li>Click "Sales Report." </li>
        </ol>

        <p>
          Understanding how to access your Gross Sales Reports are essential in documenting your taxes, monitoring loss
          and profit, and improving your overall sales. Your gross sales report is calculated automatically and found on
          your Mercari account.{' '}
        </p>
        <p>The report includes the following: </p>
        <ul>
          <li>Item ID (Your unique product identifier) </li>
          <li>Sold Date</li>
          <li>Canceled Date </li>
          <li>Completed Date</li>
          <li>Listing Title (Your item's listed Title) </li>
          <li>Order Status (Orders included here are item's sold but not yet completed or canceled) </li>
          <li>Shipped to State (The state where you sent a purchased item) </li>
          <li>Shipped from State (The state where your items were shipped from)</li>
          <li>Item Price (The final selling price paid to the seller)</li>
          <li>Buyer Shipping Fee (Separate cost of the shipping fee paid by the buyer) </li>
          <li>Seller Shipping Fee (The cost of the shipping fee paid by the seller)</li>
          <li>Mercari Selling Fee (The commission fee deducted from your item price after the order completion.) </li>
          <li>
            Payment Processing Fee (The fee collected from processing the payment of the buyer from your item price)
          </li>
          <li>Shipping Adjustment Fee (Additional costs paid by the seller for any shipping discrepancy) </li>
          <li>
            Seller Sales Profit (The net amount paid from the final item price to the seller less any applicable seller
            paid shipping, Mercari selling, and payment processing fees
          </li>
          <li>
            Sales Tax Charged to Buyer (Separate stated sales tax paid by the buyer and remitted directly to the state
            under Mercari's sales tax registration.{' '}
          </li>
          <li>
            Gross Payments (The total amount processed by Mercari for all completed sales during the calendar year){' '}
          </li>
        </ul>

        <p>
          The new tax reporting threshold is at $600 in the calendar year. If you meet the threshold, you will be
          requested to fill out Form 1099-K and update your tax information. This data will be reported to the IRS
          (Internal Revenue Services) and other relevant state taxing authorities.{' '}
        </p>
        <p>Aside from the new tax reporting threshold, you should also know how Sales Tax works for Mercari Seller.</p>

        <h3>Sales Tax for Sellers</h3>
        <p>
          Sales tax is paid to the applicable federal and state taxing authority governing sales of specific goods and
          services. Ideally, sellers collect these funds separately on top of their item price from the buyer at the
          point of purchase.{' '}
        </p>
        <p>
          However, there has been a shift from the tax collection responsibilities of third-party sellers to the
          marketplace facilitator. Mercari is one of those online marketplaces that calculates, collects, reports, and
          remits applicable sales tax on behalf of its sellers.{' '}
        </p>
        <p>
          Any applicable taxes will be added to the buyer's order as a separate charge from its item price and shipping
          costs (unless the seller chooses to pay for the shipping.) Sales taxes are paid under Mercari's registered
          sales tax identification numbers. The following are included in the calculation, collection, reporting, and
          remittance of applicable sales taxes.{' '}
        </p>
        <ul>
          <li>Shipping costs located in certain states may be subject to sales tax. </li>
          <li>
            Using the Mercari shipping label, shipping costs may be subject to sales tax (depending on the state.)
          </li>
          <li>
            Sales tax added to the buyer's order and at what rate depends on the nature of their purchased items and
            their delivery address.{' '}
          </li>
          <li>
            Sales tax rates are determined based on the combined state and any applicable country, city, or local taxes
            based on the delivery address.{' '}
          </li>
        </ul>

        <p>
          No additional fees are being collected to sellers for the processing, collection, and remittance of sales tax
          by Mercari. However, sellers cannot opt out of Mercari's sales tax collection when the country, state, city
          require it or other local laws they are located from.{' '}
        </p>

        <h3>Final Thoughts </h3>
        <p>
          To sum it up, sellers should fill out their substitute w-9 form when requested and submit their Form 1099-K
          timely. This way, they can avoid tax complications account and selling restrictions in Mercari and other
          online marketplaces.{' '}
        </p>
        <p>
          However, not all marketplace sellers have the time to do all these things. Marketplace sellers have their
          hands on a lot of things. This includes taking photos, answering inquiries, sharing, liking, shipping,
          after-sales, and more.{' '}
        </p>
        <p>
          We at OneShop know the struggle every marketplace sellers face. This is why our system makes reselling easy
          fun and saves you plenty of time to do more important things, like updating your tax identification
          information on time or spending some time with your loved ones.{' '}
        </p>
        <p>
          See the difference OneShop make to your reselling business. Sign up here and start your 7-day free trial on
          us! No commitment and credit card required! Visit{' '}
          <a href='https://tools.oneshop.com/'>https://tools.oneshop.com/</a> to learn more.{' '}
        </p>
      </BlogPage>
      <Footer />
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  scrollView: {
    flex: 1,
  },
});
